// extracted by mini-css-extract-plugin
export var bold = "fp-cj";
export var caption = "fp-aj";
export var ctaLarge = "fp-fj";
export var eyebrow = "fp-9i";
export var h1 = "fp--i";
export var h1Large = "fp-0i";
export var h2 = "fp-1i";
export var h3 = "fp-3i";
export var h4 = "fp-4i";
export var h5 = "fp-5i";
export var h6 = "fp-6i";
export var italic = "fp-dj";
export var markdownImgContainer = "fp-ij";
export var markdownText = "fp-gj";
export var markdownTextArticle = "fp-jj";
export var markdownTextLegal = "fp-2i";
export var markdownText__highlight = "fp-hj";
export var mt0 = "fp-Ui";
export var mt1 = "fp-Vi";
export var mt2 = "fp-Wi";
export var mt3 = "fp-Xi";
export var mt4 = "fp-Yi";
export var mt5 = "fp-Zi";
export var mt6 = "fp-_i";
export var p = "fp-7i";
export var pSmall = "fp-8i";
export var sideNavLabel = "fp-ej";
export var stat = "fp-bj";